module.exports = __webpack_public_path__ + "img/6668d3b.png";